var map = {
	"./baby_changing.svg": 65355,
	"./bar.svg": 40838,
	"./disabled_suite.svg": 35878,
	"./dish_washing.svg": 78217,
	"./dog_wash.svg": 13875,
	"./dogwash.svg": 4518,
	"./drainage.svg": 76984,
	"./electric.svg": 84714,
	"./entertainment.svg": 40035,
	"./family.svg": 24627,
	"./family_room.svg": 74235,
	"./freezers.svg": 53571,
	"./hair_dryers.svg": 24363,
	"./hairdryer.svg": 20223,
	"./ironing.svg": 78023,
	"./laundry.svg": 11346,
	"./play_area.svg": 38799,
	"./playpark.svg": 57005,
	"./restaurant.svg": 10306,
	"./showers.svg": 35864,
	"./takeaway.svg": 94308,
	"./tv.svg": 60141,
	"./washroom.svg": 22479,
	"./waste_disposal.svg": 17887,
	"./water.svg": 57984,
	"./wetsuit.svg": 51106,
	"./wetsuit_wash.svg": 14372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83347;